/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeActionItem,
  BaSeButton,
  BaSeContainer,
  BaSeHeading4,
  BaSeParagraph,
  BaSeShapeButton,
  BaSeSmall1,
  BaSeTheme,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';

import { format } from 'date-fns';
import * as React from 'react';
import { useAnswerController } from '../../../../hooks/controllers/answer-controller';
import { useEmailController } from '../../../../hooks/controllers/email-controller';
import { useInterviewController } from '../../../../hooks/controllers/interview-controller';
import { useReportController } from '../../../../hooks/controllers/report-controller';
import { useMessage } from '../../../../hooks/messages/useMessage';
import { useModule } from '../../../../hooks/module/module';
import { useInterviewService } from '../../../../hooks/services/interview-service.js';
import { useRegionalService } from '../../../../hooks/services/regional-service.js';
import { ColumnFilter } from '../../components/data-table/column-filter';
import { ColumnRuralFilter } from '../../components/data-table/column-rural-filter.jsx';
import { DataRegister } from '../../components/data-table/data-register.jsx';
import { EmailDate } from '../../components/data-table/email-date';
import { InterviewResult } from '../../components/data-table/interview-result';
import { InterviewStatus } from '../../components/data-table/interview-status';
import { PersonalData } from '../../components/data-table/personal-data';
import { SituationRural } from '../../components/data-table/situation-rural.jsx';
import { ContentContext } from '../../context/content-context';
import { useTableInterview } from '../../context/table-interview-context.jsx';
import ManageRegional from '../manage-regional/manage-regional.jsx';
import {
  Banner,
  BoxHeader,
  BoxUserName,
  ContainerPopover,
  Content,
  ContentActions,
  ContentOptions,
  CustomFilterWrapper,
  DataTableWrapper,
  ItemResultEntrevista,
  ListContainer,
} from './candidates-styled';
import SelectionActionsButtons from './components/SelectionActionsButtons/selection-actions-buttons.jsx';
import DateRange from './components/custom-filter-table/date-range.jsx';
import {
  filterReducer,
  initialFilters,
} from './components/custom-filter-table/filter-reducer.js';
import FilterTable from './components/custom-filter-table/filter-table.jsx';
import MyRecords from './components/custom-filter-table/my-records.jsx';
import ProcessingDate from './components/custom-filter-table/procesing-date.jsx';
import RegisteredPortal from './components/custom-filter-table/registered-portal.jsx';
import ManageClass from './components/manage-class/manage-class.jsx';
import { NewClassRoomContext } from './context/new-class-room-context.jsx';
import { useConfigTable } from './hook/useConfigTable';
import { useGeneralSearch } from './hook/useGeneralSearch';
import { useManageClass } from './hook/useManageClass';
import { useMenu } from './hook/useMenu.jsx';
import { useReginal } from './hook/useRegiona..jsx';
import MainContent from './main-content';

const hasCustomFilter = true;
const cache = Sebrae.StorageUtil.inTemporaryStore();
const cacheKey = '@empretec:cpfSearched';
const cacheKeySebrae = '@empretec:sebrae';
const cacheKeyFiltersFixed = '@empretec:filtros-fixados';

// eslint-disable-next-line sonarjs/cognitive-complexity
export const Candidates = () => {
  const { moduleSelected } = useModule();
  const { isAuthenticated, tokenInfo, hasRole } = Sebrae.useAuth();
  // const [cpfSearched, setCpfSearched] = React.useState('');
  const { getQueryString } = Sebrae.useRouter();
  const { clear, cpfSearched } = useGeneralSearch();
  const { hasAlertAwaitinAvaliation } = useInterviewService();

  const { getDownloadCertificate } = useInterviewController();

  const { fetchData, data, loading } = useTableInterview();

  const {
    loading: loadingRegional,
    data: dataRegional,
    fetchRegional,
  } = useRegionalService();


  const { resendAnswerInterviewmutiple } = useAnswerController();

  const { sendEmailSubscription } = useEmailController();
  const { downloadPdf, getClassReport } = useReportController();
  const { handleSuccess, handleError, handleAttention } = useMessage();
  const { settingsTable } = useConfigTable();

  const { showContentManageClass, showManagerRegional } =
    React.useContext(ContentContext);
  const [itemsSelectTable, setItemsSelectTable] = React.useState([]);
  const [isAllSelect, setIsAllSelect] = React.useState(false);

  const { filters, handleColumns, handleSyncClassFoco, syncLoading } = React.useContext(NewClassRoomContext);

  const [filtersCustom, dispatch] = React.useReducer(
    filterReducer,
    initialFilters,
  );

  const [fixedFilters, setFixedFilters] = React.useState({
    dateRange: false,
    processingDate: false,
    myRecords: false,
    registeredOnPortal: false,
  });

  const handleFixedFilter = React.useCallback((filterKey) => {
    setFixedFilters((prev) => {
      const newData = {
        ...prev,
        [filterKey]: !prev[filterKey],
      };
      cache.setItem(cacheKeyFiltersFixed, newData);
      return newData;
    });
  }, []);

  const {
    respostas,
    showNotas,
    notasRespostas,
    openDialogCpf,
    setShowNotas,
    openDialogNewCandidate,
    openDialogActiveInterview,
    openDialogVisualizarHistorico,
    formatDate,
    setCodigoRespostas,
    openDialogGenerateCertificate,
    openDialogSendMultipleCertificate,
    showAvaliableCandidate,
    setShowAvaliableCandidate,
    respostasQuestionarioStartup,
    getInterviewDataStartup,
    hasApprove,
    setHasApprove,
    showAvaliableRuralCandidate,
    dataToAvaliationRural,
    setShowAvaliableRuralCandidate,
    getMenuItems,
  } = useMenu();
  const { openDialogNewRegional } = useReginal();

  const { openDialogNewClassRoom } = useManageClass();

  const historico = (values) => {
    openDialogVisualizarHistorico(values);
    setCodigoRespostas(values.id);
  };

  React.useEffect(() => {
    if (!hasRole('ADMINISTRADOR')) return;
    hasAlertAwaitinAvaliation()
      .then((response) => {
        if (response) {
          handleAttention(
            ' Existe(m) entrevista(s) no sistema "Aguardando avaliação".',
          );
        }
      })
      .catch(() => {
        handleError(
          'Erro ao analisar se existem entrevistas Aguardando avaliação.',
        );
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleAttention, handleError, hasRole]);

  const [open, setOpen] = React.useState(false);
  const popoverRef = React.useRef(null);

  const handleChangeCustomFilter = React.useCallback((key, value) => {
    dispatch({ type: 'SET_FILTER', payload: { key, value } });
  }, []);

  const handleClearFilter = React.useCallback((key, value) => {
    dispatch({ type: 'RESET_FILTERS' });
  }, []);

  React.useEffect(() => {
    if (cache.hasItem(cacheKeyFiltersFixed)) {
      setFixedFilters(cache.getItem(cacheKeyFiltersFixed));
    }
  }, []);

  React.useEffect(() => {
    const handleClickOutside = (e) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  React.useEffect(() => {
    const interview = getQueryString('interview');

    if (interview) {
      getInterviewDataStartup(interview);
      setShowAvaliableCandidate(true);
    }
  }, [
    moduleSelected,
    getQueryString,
    getInterviewDataStartup,
    setShowAvaliableCandidate,
  ]);

  const textFilter = React.useCallback(async (setFilter, term) => {
    const cachedUf = cache.getItem(cacheKeySebrae);
    const includeUF = cachedUf !== 'NA' && term === '';

    setFilter((currentFilter) => ({
      ...currentFilter,
      ufs: includeUF ? [cachedUf] : [],
      fieldOfResearch: term,
    }));
  }, []);

  const commonConfigTable = [
    {
      accessorKey: 'candidate.name',
      header: 'Dados pessoais',
      mapper: ({ values }) => <PersonalData props={values} />,
    },
    {
      accessorKey: 'city.uf.initials',
      header: 'UF',
      mapper: ({ values }) => {
        return (
          <BaSeSmall1
            isBold
            color={BaSeTheme.colors.institucionais.cinzaSebrae45}
          >
            {values.city.uf.initials}
          </BaSeSmall1>
        );
      },
    },
    {
      accessorKey: 'nome_cidade',
      header: 'Cidade',
      mapper: ({ values }) => (
        <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
          {values.city.name}
        </BaSeSmall1>
      ),
    },
  ];

  const configRuralTable = [
    ...commonConfigTable,
    {
      id: 'registerData',
      accessorKey: 'registerData',
      header: 'Data de inscrição',
      mapper: ({ values }) => <DataRegister props={values} />,
    },
    {
      accessorKey: 'situationInterview',
      header: 'Situação do participante',
      mapper: ({ values }) => {
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <SituationRural props={values} />
            <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
              {values.processingDate
                ? ` ${settingsTable.processingDateTitle}: ${formatDate(
                  new Date(values.processingDate),
                )}`
                : ''}
            </BaSeSmall1>
          </div>
        );
      },
    },
    {
      header: 'Opções',
      mapper: ({ values, reloadData }) => (
        <ContentOptions>
          <BaSeActionItem
            position="top-right"
            minWidth="310px"
            closeOnAction={false}
            color={BaSeTheme.colors.institucionais.azulSebrae10}
            items={getMenuItems(values, reloadData, 1)}
          />
          {values.hasHistoric && (
            <BaSeShapeButton
              buttonType="button"
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
              nameIcon="file-search-alt"
              onClick={() => {
                historico(values);
              }}
              shape="square"
              size="medium"
              sizeIcon="medium"
              tooltip={{
                width: '150',
                direction: 'bottom',
                message: 'Visualizar histórico',
                color: `${BaSeTheme.colors.institucionais.cinzaSebrae60}`,
              }}
              type="tertiary"
            />
          )}
        </ContentOptions>
      ),
    },
  ];

  const configTable = [
    ...commonConfigTable,
    {
      id: 'sendingRegistrationEmail',
      header: 'E-mail de inscrição',
      mapper: ({ values }) => <EmailDate props={values} />,
    },
    {
      accessorKey: 'statusCompletingInterview',
      header: `${settingsTable.statusColumn}`,
      mapper: ({ values }) => <InterviewStatus props={values} />,
    },
    {
      accessorKey: 'statusInterview',
      header: `${settingsTable.resultColumn}`,
      mapper: ({ values }) => (
        <ItemResultEntrevista>
          <InterviewResult props={values} />
          <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
            {values.processingDate
              ? ` ${settingsTable.processingDateTitle}: ${formatDate(
                new Date(values.processingDate),
              )}`
              : ''}
          </BaSeSmall1>
        </ItemResultEntrevista>
      ),
    },
    {
      header: 'Opções',
      mapper: ({ values, reloadData }) => (
        <ContentOptions>
          <BaSeActionItem
            position="top-right"
            minWidth="310px"
            closeOnAction={false}
            color={BaSeTheme.colors.institucionais.azulSebrae10}
            items={getMenuItems(values, reloadData, 1)}
          />
          {values.hasHistoric && (
            <BaSeShapeButton
              buttonType="button"
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
              nameIcon="file-search-alt"
              onClick={() => historico(values)}
              shape="square"
              size="medium"
              sizeIcon="medium"
              tooltip={{
                width: '150',
                direction: 'bottom',
                message: 'Visualizar histórico',
                color: `${BaSeTheme.colors.institucionais.cinzaSebrae60}`,
              }}
              type="tertiary"
            />
          )}
        </ContentOptions>
      ),
    },
  ];

  const columnRuralConfig = [
    {
      columnId: 'city.uf.initials',
      columnFilterIconProps: { shape: 'square' },
      renderColumnFilter: ({ setFilter, setTags, closeFilter }) => {
        return (
          <ColumnFilter
            setFilter={setFilter}
            setTags={setTags}
            closeFilter={closeFilter}
            columnId="ufs"
          />
        );
      },
    },
    {
      columnId: 'nome_cidade',
      columnFilterIconProps: { shape: 'square' },
      renderColumnFilter: ({ setFilter, setTags, closeFilter }) => {
        return (
          <ColumnFilter
            setFilter={setFilter}
            setTags={setTags}
            closeFilter={closeFilter}
            columnId="cities"
          />
        );
      },
    },
    {
      columnId: 'situationInterview',
      columnFilterIconProps: { shape: 'square' },
      renderColumnFilter: ({ setFilter, setTags, closeFilter }) => {
        return (
          <ColumnRuralFilter
            setFilter={setFilter}
            setTags={setTags}
            closeFilter={closeFilter}
            columnId="situationInterview"
          />
        );
      },
    },
  ];

  const columnCommonConfig = [
    {
      columnId: 'city.uf.initials',
      columnFilterIconProps: { shape: 'square' },
      renderColumnFilter: ({ setFilter, setTags, closeFilter }) => {
        return (
          <ColumnFilter
            setFilter={setFilter}
            setTags={setTags}
            closeFilter={closeFilter}
            columnId="ufs"
          />
        );
      },
    },
    {
      columnId: 'nome_cidade',
      columnFilterIconProps: { shape: 'square' },
      renderColumnFilter: ({ setFilter, setTags, closeFilter }) => {
        return (
          <ColumnFilter
            setFilter={setFilter}
            setTags={setTags}
            closeFilter={closeFilter}
            columnId="cities"
          />
        );
      },
    },
    {
      columnId: 'sendingRegistrationEmail',
      columnFilterIconProps: { shape: 'square' },
      renderColumnFilter: ({
        setFilter,
        setTags,
        closeFilter,
        resetSelection,
      }) => {
        return (
          <ColumnFilter
            setFilter={setFilter}
            setTags={setTags}
            closeFilter={closeFilter}
            columnId="emails"
          />
        );
      },
    },
    {
      columnId: 'statusCompletingInterview',
      columnFilterIconProps: { shape: 'square' },
      renderColumnFilter: ({ setFilter, setTags, closeFilter }) => {
        return (
          <ColumnFilter
            setFilter={setFilter}
            setTags={setTags}
            closeFilter={closeFilter}
            columnId="statusCompletingInterviews"
          />
        );
      },
    },
    {
      columnId: 'statusInterview',
      columnFilterIconProps: { shape: 'square' },
      renderColumnFilter: ({ setFilter, setTags, closeFilter }) => {
        return (
          <ColumnFilter
            setFilter={setFilter}
            setTags={setTags}
            closeFilter={closeFilter}
            columnId="statusInterviews"
          />
        );
      },
    },
  ];

  const columnConfig =
    moduleSelected?.id === 4 ? columnRuralConfig : columnCommonConfig;

  const getSelectionIconActions = React.useCallback(
    (isAllSelected, selectedItems) =>
      !isAllSelected && selectedItems.length === 0
        ? [
          {
            nameIcon: 'envelope',
            isDisabled: true,
            onClick: () => { },
          },
          {
            nameIcon: 'file-export',
            isDisabled: true,
            onClick: () => { },
          },
          {
            nameIcon: 'newspaper',
            isDisabled: true,
            onClick: () => { },
          },
          {
            nameIcon: 'newspaper',
            isDisabled: true,
            onClick: () => { },
          },
          {
            nameIcon: 'print',
            isDisabled: true,
            onClick: () => { },
          },
        ]
        : [],
    [],
  );

  const exportClassReport = React.useCallback(
    (interviews) => {
      if (
        interviews.filter((interview) => interview.statusInterview !== 'APTO')
          .length
      ) {
        handleAttention(
          'Relatório permitido somente para candidatos com o status da entrevista "Finalizada" ou "Certificada" e resultado "Apto".',
        );
        return;
      }

      if (interviews.length > 40) {
        handleAttention('Limite máximo de 40 candidatos por relatório.');
        return;
      }

      getClassReport(interviews.map((s) => s.id)).then((pdf) => {
        const nameReport = `Relatório da Turma-${format(
          new Date(),
          'dd-MM-yyyy',
        )}.pdf`;
        pdf && downloadPdf(pdf, nameReport);
      });
    },
    [downloadPdf, getClassReport, handleAttention],
  );

  const sendMultipleCertificate = React.useCallback(
    (isAllSelected, interviews, reloadData) => {
      const hasNotCertificate = interviews.filter(
        (interview) => interview.statusCompletingInterview !== 'CERTIFICADA',
      );
      if (hasNotCertificate.length > 0) {
        handleAttention(
          'O envio do certificado digital é permitido somente para os candidatos com status da entrevista "Certificada".',
        );
        return;
      }

      const totalEntrevistas = interviews.length;
      if (isAllSelected || totalEntrevistas > 100) {
        handleError(
          'Somente é permitido selecionar um máximo de 100 candidatos para o envio do certificado em lote.',
        );
        return;
      }

      openDialogSendMultipleCertificate(interviews, reloadData);
    },
    [handleAttention, handleError, openDialogSendMultipleCertificate],
  );

  const printMultipleCertificate = React.useCallback(
    (isAllSelected, interviews, reloadData) => {
      const totalEntrevistas = interviews.length;
      const hasNotCertificate = interviews.filter(
        (interview) => interview.statusCompletingInterview !== 'CERTIFICADA',
      );

      const idList = interviews.map((interview) => interview.id);

      if (hasNotCertificate.length > 0) {
        handleError(
          'A impressão dos certificados é permitida somente para os candidatos com status "Certificada".',
        );
        return;
      }

      if (isAllSelected || totalEntrevistas > 40) {
        handleAttention(
          'Somente é permitido selecionar um máximo de 40 candidatos para impressão dos certificados em lote.',
        );
        return;
      }

      getDownloadCertificate(idList).then((response) => {
        response && downloadPdf(response, 'certificado.pdf');
      });
    },
    [downloadPdf, getDownloadCertificate, handleAttention, handleError],
  );

  const sendInterviewReprocess = React.useCallback(
    (idsList) => {
      resendAnswerInterviewmutiple(idsList)
        .then(() =>
          handleSuccess(
            'Solicitação de reprocessamento da(s) entrevista(s) enviada com sucesso.',
          ),
        )
        .catch((error) => handleError(error));
    },
    [resendAnswerInterviewmutiple, handleError, handleSuccess],
  );

  const checkInterviewsForNonErrorResult = React.useCallback(
    (data) => {
      const nonErrorResult = data.filter(
        (it) => it.statusInterview !== 'ERRO_DE_PROCESSAMENTO',
      );

      if (nonErrorResult.length > 0) {
        handleAttention(
          'Reprocessamento permitido somente para as entrevistas com resultado "Erro de Processamento".',
        );
        return;
      }
      const idsList = data.map((it) => it.id);
      sendInterviewReprocess(idsList);
    },
    [handleAttention, sendInterviewReprocess],
  );

  const generateMultipleCertificate = React.useCallback(
    (isAllSelected, interviews, reloadData) => {
      const totalEntrevistas = interviews.length;

      if (isAllSelected || totalEntrevistas > 40) {
        handleError(
          'Somente é permitido selecionar um máximo de 40 candidatos para geração do certificado em lote.',
        );
        return;
      }

      const listaNaoAptos = interviews.filter(
        (interview) =>
          interview.statusInterview !== 'APTO' ||
          (interview.statusCompletingInterview !== 'FINALIZADA' &&
            interview.statusCompletingInterview !== 'EXPIRADA'),
      ).length;
      if (listaNaoAptos > 0) {
        handleError(
          'Geração dos certificados permitida somente para os candidatos com status "Finalizada" ou "Expirada" e resultado "Apto".',
        );
        return;
      }

      openDialogGenerateCertificate(interviews, reloadData);
    },
    [handleError, openDialogGenerateCertificate],
  );

  const getSelectionButtonActions = React.useCallback(
    (isAllSelected, selectedItems, reloadData) =>
      isAllSelected || selectedItems.length > 0
        ? [
          {
            leftIcon: 'envelope',
            value: 'Enviar e-mail de inscrição',
            type: 'tertiary',
            onClick: () => {
              sendEmailSubscription({
                sendAll: isAllSelected,
                idsInterviews: selectedItems.map((s) => s.id),
              }).then(() => reloadData());
            },
          },
          {
            leftIcon: 'file-export',
            value: 'Exportar lista',
            type: 'tertiary',
            onClick: () => {
              exportClassReport(selectedItems);
            },
          },
          {
            leftIcon: 'newspaper',
            value: 'Gerar certificado',
            type: 'tertiary',
            onClick: () => {
              generateMultipleCertificate(
                isAllSelected,
                selectedItems,
                reloadData,
              );
            },
          },
          {
            leftIcon: 'newspaper',
            value: 'Enviar certificado',
            type: 'tertiary',
            onClick: () => {
              sendMultipleCertificate(
                isAllSelected,
                selectedItems,
                reloadData,
              );
            },
          },
          {
            leftIcon: 'print',
            value: 'Imprimir certificado',
            type: 'tertiary',
            onClick: () => {
              printMultipleCertificate(
                isAllSelected,
                selectedItems,
                reloadData,
              );
            },
          },
          hasRole('ADMINISTRADOR')
            ? {
              leftIcon: 'system/arrow-go-back-line',
              value: 'Reprocessar',
              type: 'tertiary',
              onClick: () => {
                checkInterviewsForNonErrorResult(selectedItems);
              },
            }
            : {},
        ]
        : [],
    [
      sendEmailSubscription,
      hasRole,
      checkInterviewsForNonErrorResult,
      exportClassReport,
      generateMultipleCertificate,
      sendMultipleCertificate,
      printMultipleCertificate,
    ],
  );

  React.useEffect(() => {
    const allSmalls = document.querySelectorAll('small');

    allSmalls.forEach((el) => {
      if (el.textContent.trim() === 'Filtros ativados:') {
        // Subir na hierarquia para esconder o container pai
        let current = el;
        for (let i = 0; i < 3; i++) {
          current = current.parentElement;
          if (
            current &&
            current.querySelector('button[aria-label="Limpar filtros"]')
          ) {
            current.style.display = open ? 'none' : '';
            break;
          }
        }
      }
    });
  }, [open]);

  const convertDate = React.useCallback((isoString) => {
    if (!isoString) return '';

    function padTo2Digits(num) {
      return num.toString().padStart(2, '0');
    }

    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = padTo2Digits(date.getMonth() + 1);
    const day = padTo2Digits(date.getDate());

    return `${year}-${month}-${day}`;
  }, []);

  const hasActiveFilters = React.useMemo(() => {
    const isActive =
      filtersCustom.myRecords ||
      filtersCustom.registeredOnPortal ||
      filtersCustom.periodStart ||
      filtersCustom.periodEnd ||
      filtersCustom.initialProcessingDate ||
      filtersCustom.finalProcessingDate;

    return isActive ? BaSeTheme.colors.institucionais.azulSebrae60 : 'default';
  }, [filtersCustom]);

  const buildCustomFilter = React.useCallback(
    (setFilter) => {
      return (
        <CustomFilterWrapper>
          <ContainerPopover>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <BaSeParagraph>Aplicar filtro</BaSeParagraph>
              <BaSeShapeButton
                buttonType="button"
                color={hasActiveFilters}
                nameIcon="filter"
                onClick={() => {
                  setOpen((prev) => !prev);
                }}
                shape="square"
                size="extra-small"
                sizeIcon="medium"
                type="secondary"
              />

              {open && (
                <FilterTable
                  popoverRef={popoverRef}
                  setFilter={setFilter}
                  setOpen={setOpen}
                  settingsTable={settingsTable}
                  fixedFilters={fixedFilters}
                  handleFixedFilter={handleFixedFilter}
                  handleChangeCustomFilter={handleChangeCustomFilter}
                  filtersCustom={filtersCustom}
                  handleClearFilter={handleClearFilter}
                  convertDate={convertDate}
                />
              )}
            </div>
          </ContainerPopover>

          <div style={{ display: 'flex', gap: 8 }}>
            {fixedFilters.dateRange && (
              <DateRange
                filters={filtersCustom}
                title={settingsTable.custonFilterInscriptionDate}
                handleChange={handleChangeCustomFilter}
                fixedFilters={fixedFilters}
                handleFixedFilter={handleFixedFilter}
                setFilter={setFilter}
                insideFilter={false}
                convertDate={convertDate}
              />
            )}

            {fixedFilters.processingDate && (
              <ProcessingDate
                filters={filtersCustom}
                title={settingsTable.custonFilterDate}
                handleChange={handleChangeCustomFilter}
                fixedFilters={fixedFilters}
                handleFixedFilter={handleFixedFilter}
                insideFilter={false}
                setFilter={setFilter}
                convertDate={convertDate}
              />
            )}

            {fixedFilters.myRecords && (
              <MyRecords
                filters={filtersCustom}
                handleChange={handleChangeCustomFilter}
                fixedFilters={fixedFilters}
                handleFixedFilter={handleFixedFilter}
                insideFilter={false}
                setFilter={setFilter}
              />
            )}

            {fixedFilters.registeredOnPortal && (
              <RegisteredPortal
                filters={filtersCustom}
                fixedFilters={fixedFilters}
                handleChange={handleChangeCustomFilter}
                handleFixedFilter={handleFixedFilter}
                insideFilter={false}
                setFilter={setFilter}
              />
            )}
          </div>

          <ContentActions>
            <SelectionActionsButtons
              isAllSelected={isAllSelect}
              itemsSelectTable={itemsSelectTable}
              moduleSelected={moduleSelected}
            />
          </ContentActions>
        </CustomFilterWrapper>
      );
    },
    [
      filtersCustom,
      fixedFilters,
      hasActiveFilters,
      handleChangeCustomFilter,
      handleClearFilter,
      handleFixedFilter,
      isAllSelect,
      itemsSelectTable,
      moduleSelected,
      open,
      settingsTable,
      convertDate,
    ],
  );

  const clearAll = React.useCallback(() => {
    fetchData({
      filter: {
        fieldOfResearch: '',
        sortField: 'interviewDate',
        filterType: '',
        filterCityName: '',
        originInterview: 'MANAGER',
        ufs: [],
        cities: [],
        statusCompletingInterviews: [],
        statusInterviews: [],
        emails: [],
      },
      page: {
        size: 10,
        index: 0,
      },
      sort: { type: 'DESC' },
    });
  }, [fetchData]);
  const handleUpdateColumns = React.useCallback(() => {
    handleColumns(filters);
  }, [filters, handleColumns]);

  const returnDescription = React.useCallback(() => {
    if (showContentManageClass) {
      return 'Esse é seu espaço para criar turmas e fazer a gestão dos participantes inscritos para o Seminário.';
    } else if (showManagerRegional) {
      return 'Este é seu espaço para criar novas regionais e fazer a gestão das cidades e gestores vinculados.';
    } else {
      return 'Esse é seu espaço para inscrever e fazer a gestão das entrevistas dos candidatos ao Empretec.';
    }
  }, [showContentManageClass, showManagerRegional]);

  return (
    <ListContainer>
      <Content gradientColor={moduleSelected?.settingsMap?.primaryColor}>
        <BaSeContainer delimitedOnBreakpoint="desktop">
          <Banner
            imageBannerManager={
              moduleSelected?.settingsMap?.empretecManagerActorSmall
            }
          />
          <DataTableWrapper>
            <BoxHeader>
              <BoxUserName>
                <BaSeHeading4
                  color={BaSeTheme.colors.institucionais.cinzaSebrae75}
                  isBold={true}
                >
                  {isAuthenticated && `Olá, ${tokenInfo?.name}!`}
                </BaSeHeading4>
                <BaSeParagraph
                  color={BaSeTheme.colors.institucionais.cinzaSebrae75}
                >
                  {returnDescription()}
                </BaSeParagraph>
              </BoxUserName>

              <>
                {showContentManageClass ? (
                  <div style={{ display: 'flex', alignItems: "center", gap: '1em' }}>
                    <BaSeButton
                      buttonType="button"
                      leftIcon="sync"
                      loadingText="Sincronizando..."
                      isLoading={syncLoading}
                      rightIcon=""
                      size="medium"
                      value="Sincronizar (FOCO)"
                      width=""
                      onClick={handleSyncClassFoco}
                    />
                    <BaSeButton
                      buttonType="button"
                      color={BaSeTheme.colors.institucionais.cinzaSebrae10}
                      leftIcon="plus"
                      loadingText="Carregando..."
                      rightIcon=""
                      size="medium"
                      type="secondary"
                      value="Nova Turma"
                      width=""
                      onClick={() => {
                        openDialogNewClassRoom(handleUpdateColumns);
                      }}
                    />
                  </div>
                ) : showManagerRegional ? (
                  <BaSeButton
                    buttonType="button"
                    color={BaSeTheme.colors.institucionais.cinzaSebrae10}
                    leftIcon="plus"
                    loadingText="Carregando..."
                    rightIcon=""
                    size="medium"
                    type="secondary"
                    value="Nova Regional"
                    width=""
                    onClick={() => openDialogNewRegional(fetchRegional)}
                  />
                ) : (
                  <BaSeButton
                    buttonType="button"
                    color={BaSeTheme.colors.institucionais.cinzaSebrae10}
                    leftIcon="plus"
                    loadingText="Carregando..."
                    rightIcon=""
                    size="medium"
                    type="secondary"
                    value="Novo Candidato"
                    width=""
                    onClick={() =>
                      openDialogCpf(
                        openDialogActiveInterview,
                        openDialogNewCandidate,
                        fetchData,
                      )
                    }
                  />
                )}
              </>
            </BoxHeader>

            {showContentManageClass ? (
              <ManageClass />
            ) : showManagerRegional ? (
              <ManageRegional
                loading={loadingRegional}
                fetchRefional={fetchRegional}
                data={dataRegional}
              />
            ) : (
              <MainContent
                setShowAvaliableRuralCandidate={setShowAvaliableRuralCandidate}
                dataToAvaliationRural={dataToAvaliationRural}
                showNotas={showNotas}
                setShowNotas={setShowNotas}
                showAvaliableCandidate={showAvaliableCandidate}
                cpfSearched={cpfSearched}
                notasRespostas={notasRespostas}
                respostas={respostas}
                fetchData={fetchData}
                setShowAvaliableCandidate={setShowAvaliableCandidate}
                respostasQuestionarioStartup={respostasQuestionarioStartup}
                showAvaliableRuralCandidate={showAvaliableRuralCandidate}
                configTable={
                  moduleSelected?.id === 4 ? configRuralTable : configTable
                }
                columnConfig={columnConfig}
                cache={cache}
                data={data}
                loading={loading}
                hasCustomFilter={hasCustomFilter}
                cacheKeySebrae={cacheKeySebrae}
                cacheKey={cacheKey}
                clear={clear}
                clearAll={clearAll}
                getSelectionIconActions={getSelectionIconActions}
                buildCustomFilter={buildCustomFilter}
                getSelectionButtonActions={getSelectionButtonActions}
                hasApprove={hasApprove}
                setHasApprove={setHasApprove}
                setItemsSelectTable={setItemsSelectTable}
                setIsAllSelect={setIsAllSelect}
                textFilter={textFilter}
                moduleSelected={moduleSelected}
                settingsMap={moduleSelected?.settingsMap}
              />
            )}


          </DataTableWrapper>
        </BaSeContainer>
      </Content>
    </ListContainer>
  );
};
